<template>
  <div>
    <Head title="隱私權政策" />
    <ScrollTop />

    <div class="w-full mt-5">
      <figure class="my-16">
        <img src="/images/privacy01.jpg">
    </figure>
    <div>
        <p>
            FoodyHome 吃貨家 網站隱私權條款 :
        </p>
        <p>
            FoodyHome吃貨家網站係由友力食業有限公司(統一編號 : 90894058)所經營。這份隱私權的保障聲明，為因應社會環境及法令規定的變遷與科技的進步，友力食業有限公司為保護客戶隱私，有權修改這份公告聲明，並儘速更新與告知客戶。友力食業有限公司非常尊重客戶的隱私權，對於客戶資料的蒐集、處理及利用均遵守中華民國政府之「個人資料保護法」及相關法令規範，您可以參照以下隱私權政策，了解我們的具體措施；歐盟會員身份不適用本公司目前所有服務，若您未告知是否具備歐盟會員國國民身份，本公司將認定您不具備歐盟國民身份，並會為您提供服務。
        </p>
        <br>
        <p>
            1.本隱私權政策適用之範圍 : 
        </p>
        <p>
            本隱私權政策及其所包含之告知事項，僅適用於友力食業有限公司所擁有及經營的網站。本網站內可能包含許多連結、或其他合作夥伴所提供的服務，關於該等連結網站或合作夥伴網站的隱私權聲明及與個人資料保護有關之告知事項，請參閱各該連結網站或合作夥伴網站。
        </p>
        <br>
        <p>
            2.客戶資料蒐集、處理及利用之合法依據 : 
        </p>
        <ul>
            <li>
                <p>
                    (1)我們擁有客戶的個人資料，是由FoodyHome吃貨家網站及其相應行動應用程式註冊會員或消費之客戶所提供。
                </p>
            </li>
            <li>
                <p>
                    (2)由我們在其他行銷或異業結盟活動中合法取得(包括但不限於自業務合作廠商處取得)，本公司針對前段資料，將在處理及利用前，向您說明資料來源及各必要告知事項。
                </p>
            </li>
            <li>
                <p>
                    (3)本公司擁有您之個人資料均依照個人資料保護法之規定進行蒐集、處理及利用 : <br>
                    <div class="ml-6">
                        <p>
                            ①您加入本公司會員時，透過您同意提供之資料。<br>
                            ②與您有契約或類似契約之關係，如您進行商品訂購、本公司進行商品配送等。<br>
                            ③具法律明文規定，要求本公司進行蒐集、處理或利用。<br>
                            ④您自行公開或已合法公開之資料，惟本公司不主動進行左列資料之蒐集、處理或利用。<br>
                            ⑤為增進公共利益，惟本公司僅於維護資訊安全、防止詐欺等合法利益下進行必要及有限之資料處理。<br>
                            ⑥對您的權益無侵害，惟本公司僅於核實本公司資料蒐集目的下，進行必要及合理之處置。<br>
                        </p>
                    </div>

                </p>
            </li>
            <li>
                <p>
                    (4)本公司不處理個人資料保護法第6條所指之各項資料。
                </p>
            </li>
        </ul>
        <br>
        <p>
            3.客戶資料蒐集種類 : 
        </p>
        <ul>
            <li>
                <p>
                    (1)我們會依據FoodyHome吃貨家網站提供之服務，請客戶提供必要之作業資料，若您不提供相關資料，或提供之資料不正確，將影響本公司之服務品質 :<br>
                    <div class="ml-6">
                        <p>
                            ①FoodyHome吃貨家之會員或客戶，我們會請您提供基本資料 : 包含您提供之姓名、性別、身分證統一編號、出生年月日、聯絡電話、聯絡地址、電子郵件信箱及其他您主動提供之資料。<br>
                            ②當您指定商品配送服務時，我們會請您提供配送資料 : 包含收件人之姓名、聯絡電話、聯絡地址及其他必要配送聯絡資料。<br>
                            ③當您有實際消費行為時，我們會留存您的帳務資料。但若您選擇使用應用程式內含的Apple Pay、Google Pay或其他第三方的付款方式，相關資訊將會依據該第三方服務供應商的隱私權條款進行保護與管理。<br>
                            ④我們基於提供市場分析、贈獎活動、會員及客戶權益通知等相關服務，將會為必要作業將請您提供其他資料。<br>
                        </p>
                    </div>

                </p>
            </li>
            <li>
                <p>
                    (2)依據法務部頒布之「個人資料保護法之特定目的及個人資料之類別」，本公司蒐集、處理、利用及保有您個人資料之種類列示如下 : <br>
                    <div class="ml-6">
                        <p>
                            Ｃ○○一 辨識個人者。(例如：姓名、職稱、住址、工作地址、以前地址、住家電話號碼、行動電話、網路平臺申請之帳號、會員編號、通訊及戶籍地址、電子郵遞地址及其他任何可辨識資料本人者等。)<br>
                            Ｃ○○二 辨識財務者。(例如：金融機構帳戶之號碼與姓名、信用卡或簽帳卡之號碼、保險單號碼、個人之其他號碼或帳戶等。)<br>
                            Ｃ○○三 政府資料中之辨識者。(例如：身分證統一編號、護照號碼等。)<br>
                            Ｃ○一一 個人描述。(例如：年齡、性別、出生年月日、出生地、國籍、聲音等。)<br>
                            Ｃ○二一 家庭情形。(例如：結婚有無、配偶或同居人之姓名、前配偶或同居人之姓名、結婚之日期、子女之人數等。)<br>
                            Ｃ○二三 家庭其他成員之細節。(例如：子女、受扶養人、家庭其他成員或親屬、父母等。)<br>
                            Ｃ○三一 住家及設施。(如：住所地址)<br>
                            Ｃ○三三 移民情形。(例如：護照)<br>
                            Ｃ○三四 旅行及其他遷徙細節。(例如：旅行細節)<br>
                            Ｃ○三六 生活格調。(例如：使用消費品之種類及服務之細節、個人或家庭之消費模式等。)<br>
                            Ｃ○三八 職業。(例如：學校校長、民意代表或其他各種職業等。)<br>
                            Ｃ○八一 收入、所得、資產與投資。<br>
                            Ｃ○九三 財務交易。(例如：收付金額、信用額度、保證人、支付方式、往來紀錄、保證金或其他擔保等。)<br>
                            Ｃ一○二 約定或契約。(例如：關於交易、商業、法律或其他契約、代理等。)<br>
                            Ｃ一三二 未分類之資料。(例如：無法歸類之信件、檔案、報告或電子郵件等。)
                        </p>
                    </div>

                </p>
            </li>
        </ul>
        <br>
        <p>
            4.客戶資料蒐集目的 : 
        </p>
        <ul>
            <li>
                <p>
                    (1)我們僅會在提供商品銷售、金融交易授權、物流配送、廣告行銷、市場分析、贈獎活動、會員權益通知、或其他附隨以上各樣服務及FoodyHome吃貨家未來所有可能衍生之及相關服務時，為作業之必要運用您的個人資料：<br>
                    <div class="ml-6">
                        <p>
                            ①物流寄送 : 我們會於提供客戶商品銷售、物流配送等履行訂單之服務，提供配送資料予合作廠商及物流商。<br>
                            ②金融交易授權 : 您所提供之基本資料、帳務資料及其他必要資料，將於金融交易過程(包含信用卡授權及照會)中，提供予金融機構以完成金融交易及相關業務。<br>
                            ③廣告行銷 : 為提供您更多優質商品、活動資訊及行銷新服務等。<br>
                            ④市場分析 : 依據您瀏覽廣告之內容、消費之紀錄及所提供之資料，本公司會進行市場分析，包含透過第三方使用cookie或類似技術，以開發及提供日後更優質之客戶服務。<br>
                            ※cookie是網站伺服器用來和使用者瀏覽器進行溝通的一種技術，它可能在使用者的電腦中儲存某些資訊。<br>
                            使用者可以經由瀏覽器的設定，取消或限制此項功能。<br>
                            ⑤其他業務附隨事項：依據以上所述服務目的、贈獎活動、會員相關權益通知，及您在使用FoodyHome吃貨家其他服務，有同意之前提下，於必要範圍內進行相關運用。 
                        </p>
                    </div>
                </p>
            </li>
            <li>
                <p>
                    (2)依據法務部頒布之「個人資料保護法之特定目的及個人資料之類別」，本公司蒐集、處理、利用及保有您個人資料之特定目的列示如下 :<br>
                    <div class="ml-6">
                        <p>
                            040行銷<br>
                            063非公務機關依法定義務所進行個人資料之蒐集處理及利用<br>
                            067信用卡、現金卡、轉帳卡或電子票證業務<br>
                            069契約、類似契約或其他法律關係事務<br>
                            090消費者、客戶管理與服務<br>
                            091消費者保護<br>
                            098商業與技術資訊<br>
                            107採購與供應管理<br>
                            111票券業務<br>
                            118智慧財產權、光碟管理及其他相關行政<br>
                            125傳播行政與管理<br>
                            127募款 (包含公益勸募)<br>
                            129會計與相關服務<br>
                            132經營傳播業務<br>
                            136資(通)訊與資料庫管理<br>
                            148網路購物及其他電子商務服務<br>
                            152廣告或商業行為管理<br>
                            157調查、統計與研究分析<br>
                            181其他經營合於營業登記項目或組織章程所定之業務 
                        </p>
                    </div>
                </p>
            </li>
        </ul>
        <br>
        <p>
            5.除下列情形外，我們僅會基於您授權的範圍，於您會員存續期間及服務所能到達地區內，依照前述服務目的範圍為作業之必要運用客戶資料 : 
        </p>
        <ul>
            <li>
                <p>
                    (1)法律明文規定。
                </p>
            </li>
            <li>
                <p>
                    (2)為增進公共利益所必要。
                </p>
            </li>
            <li>
                <p>
                    (3)為免除當事人之生命、身體、自由或財產上之危險。
                </p>
            </li>
            <li>
                <p>
                    (4)為防止他人權益之重大危害。
                </p>
            </li>
            <li>
                <p>
                    (5)經當事人同意。
                </p>
            </li>
            <li>
                <p>
                    (6)有利於當事人權益。
                </p>
            </li>
        </ul>
        <br>
        <p>
            6.客戶資料移轉、揭露對象及方式 : 
        </p>
        <ul>
            <li>
                <p>
                    (1)您的個人資料，本公司為主要接收者，我們僅會在充分取得您同意的前提之下，將個人資料交由本公司及我們所委任處理營業相關事務之第三人(例如：金融機構、合作廠商、物流商及業務往來之關係企業等服務提供者)運用，依照前述服務目的範圍為作業之必要運用或揭露客戶個人資料。除非另有法令規範，或另行取得您的同意，否則我們不會向前述以外之第三人揭露您的個人資料，且除與您的權利有重大影響、保護公共利益，或於取得您的同意為前提之下進行行銷，否則本公司不會主動聯繫您。
                </p>
            </li>
            <li>
                <p>
                    (2)我們提供資料予其他第三人的情形，除經過客戶本人同意，尙可能有以下情形 :<br>
                    <div class="ml-6">
                        <p>
                            ①於上開特定目的範圍作業利用之必要。<br>
                            ②合於個人資料保護法第20條但書規定為特定目的外之利用。<br>
                            ③基於法律之規定或受司法機關與其他有權機關基於法定程序之要求。<br>
                            ④在緊急情況下為維護其他會員或第三人之合法權益。<br>
                            ⑤為維護會員服務系統的正常運作。<br>
                            ⑥會員透過本服務購物、兌換贈品、參加抽獎活動等因而產生的金/物流之必要資訊。<br>
                        </p>
                    </div>
                </p>
            </li>
            <li>
                <p>
                    (3)本公司或與其合作行銷之第三方業務合作公司(下稱第三方業務合作公司)會在您同意之情形下，始得利用您的個人資料於行銷活動資訊、商品訊息或新服務等相關行銷。如您拒絕接受行銷服務或嗣後欲拒絕時，均可隨時通知我們，本公司或第三方業務合作公司將立即停止利用您的個人資料行銷。
                </p>
            </li>
        </ul>
        <br>
        <p>
            7.客戶資料保存期間及儲存保管安全 :
        </p>
        <ul>
            <li>
                <p>
                    (1)您提供之個人資料，本公司將於提供您各項會員服務為目的之存續期間持續保存，直至您刪除帳戶，或當您行使相關個人權利時為止。
                </p>
            </li>
            <li>
                <p>
                    (2)本網站主機均設有防火牆、防毒系統等相關的各項資訊安全設備及必要的安全防護措施，加以保護網站及您的個人資料。
                </p>
            </li>
            <li>
                <p>
                    (3)關於您提供的個人資料，我們將就資訊系統及公司作業規則制定嚴格規範，任何人均須在我們明定的授權規範下才能處理及利用必要之資料。
                </p>
            </li>
        </ul>
        <br>
        <p>
            8.客戶資料權利行使 : 
        </p>
        <ul>
            <li>
                <p>
                    (1)依個人資料保護法第 3 條規定，除非有其他法令限制，您就您所提供之個人資料享有查詢或請求閱覽、請求製給複製本、請求補充或更正、請求停止蒐集處理或利用(包含撤回同意、反對本公司繼續處理您的資料)、請求刪除的權利。
                </p>
            </li>
            <li>
                <p>
                    (2)如果您欲行使上述權利或是有其他諮詢、投訴事項，可以寄E-MAIL至spport@foody-home.com完成相關操作，或逕由官方客服LINE聯絡客服提出意見，我們將盡快回覆您的問題。
                </p>
            </li>
            <li>
                <p>
                    (3)本公司受理您行使各項個人權利，若為查詢或請求閱覽、請求製給複製本，本公司將於提出請求之15日內回覆，必要時得再延長15日，本公司將以電話通知您延長原因；若為請求補充或更正、請求停止蒐集處理或利用、請求刪除，本公司將於提出請求之30日內回覆，必要時得再延長30日，本公司將以電話通知您延長原因。
                </p>
            </li>
        </ul>
        <br>
        <p>
            9.在此提醒您，客戶如未提供完整的個人資料，可能無法成為我們的會員，或是享受各項相應的會員優惠服務或最新資訊 ; 如客戶提供之資料錯誤，本公司亦不受此聲明之約束。
        </p>
        <br>
        <p>
            10.關於此份隱私權聲明，我們得隨時因應社會環境及法令規定的變遷與科技的進步進行修改，並將修改內容以電子郵件、電話、型錄、通信網路、網路公告或其他適當方式通知客戶；當您使用或繼續使用FoodyHome吃貨家所提供之任一服務時，且於確認隱私及會員相關條款後，表示您已閱讀、瞭解並同意接受本服務條款之所有內容。
        </p>
        <br>
        <p>
            11.修改本使用條款的權利 :
        </p>
        <p>
            本網站保留隨時修改本網站隱私權條款的權利，修改後的本網站隱私權條款將公佈在本網站上，不另外個別通知使用者。
        </p>
        <p>
            若有任何爭議性決定，以本網站公佈的結果為準。會員及其他三人所提供之證據或建議僅供本網站參考，不對本網站具任何約束力。
        </p>
    </div>
    </div>
  </div>
</template>

<script>
import Layout from "@/Shared/Layout";
import ScrollTop from "primevue/scrolltop";

export default {
  components: { ScrollTop },
  layout: Layout,
  data() {
    return {
      activeIndex: 0,
    };
  },
  methods: {
    //
  },
  mounted() {
    //
  },
};
</script>

<style scoped>
/* HTML5 display-role reset for older browsers */
article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
menu,
nav,
section {
  display: block;
}

body {
  line-height: 1;
}

ol,
ul {
  list-style: none;
}

li {
  margin-top: 2rem;
  margin-bottom: 2rem;
  line-height: 2;
}

blockquote,
q {
  quotes: none;
}

blockquote:before,
blockquote:after,
q:before,
q:after {
  content: "";
  content: none;
}

table,
th,
td {
  border: 1px solid rgb(0, 0, 0);
  padding: 0.5rem;
  text-align: left;
  width: 24em;
}

* {
  font-family: "Noto Sans TC", sans-serif;
}

p {
  font-size: 1.25rem;
  line-height: 2;
  color: rgb(122, 119, 116);
}

h1 {
  font-size: 2.25rem;
  margin: 0.67rem 0;
  font-weight: 700;
}

h2 {
  font-size: 1.875rem;
  margin: 0.67rem 0;
  font-weight: 700;
}

h3 {
  font-size: 1.5rem;
  margin: 0.67rem 0;
  font-weight: 700;
}
</style>